// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__16JY9","container":"styles_container__22_Va","title":"styles_title__1EIc1","wrapper":"styles_wrapper__3C7Uv","answer":"styles_answer__2zVbI"};